import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import BlogPosts from 'containers/BlogPosts';

function RecentBlogPosts({ posts, isSlider }) {
  return (
    <BlogPosts
      title={<>{'Get Expert Knowledge'}</>}
      description={
        <>
          {`Our Blog features articles from property experts, private landlords,
            HMO business owners and more. We even have some articles from our
            tech team to show you just how well eqipped we are to deliver a
            great tech solution for our customers`}{' '}
          <Link to="/blog/">Start Reading</Link>
        </>
      }
      blogPosts={posts}
      isSlider={isSlider}
    />
  );
}

RecentBlogPosts.propTypes = {
  posts: PropTypes.array,
  isSlider: PropTypes.bool,
};

export default RecentBlogPosts;
